import { z } from "zod";

export enum EInstallSatisfactionApplianceInstalledDto {
  TOTALLY = "TOTALLY",
  PARTIALLY_REQUESTED_BY_SUBSCRIBER = "PARTIALLY_REQUESTED_BY_SUBSCRIBER",
  PARTIALLY_BY_TECHNICIAN = "PARTIALLY_BY_TECHNICIAN",
}

export const installSatisfactionApplianceInstalledDtoSchema = z.nativeEnum(EInstallSatisfactionApplianceInstalledDto);

export type TInstallSatisfactionApplianceInstalledDto = z.infer<typeof installSatisfactionApplianceInstalledDtoSchema>;
